import clsx from 'clsx'
import { Helmet } from "react-helmet"
import React, { useEffect, useState } from "react"

import { IDAM } from '../../api/Registry'
import { ErrorState } from '../errors/ErrorState'
import { GroupListingTab } from '../idam/GroupListingTab'
import HttpServices from '../../services/HttpServices'
import { AttributeListingTab } from '../idam/AttributeListingTab'
import { LoadingXL } from '../../components/utils/LoadingXL'
import { usePageContext } from "../../lib/guards/PageContext"
import { ModuleBreadCrumb } from '../../lib/fragments/ModuleBreadCrumb'
import { dataTypeMappings } from '../../utils/Constants'
import DropDown from '../../lib/fragments/DropDown'
import { MenuItem } from '@headlessui/react'
import { useNavigate, useLocation } from 'react-router'
import { getStandardRoute, RouteHydration } from '../../utils/Helpers'
import { CreateAttribute } from '../idam/CreateAttribute'
// import { CreateAttribute } from './CreateAttribute'

export const UserAttibutes = () => {
    const [state, setstate] = useState({
        httpStatus: 200,
        status: 'pending',
        activeTab: 'attributes',
        data: {
            grouping: null,
        },
        show: {
            uuid: null,
            modal: '',
        }
    })

    const navigate = useNavigate()
    const location = useLocation()

    const pageTitle = "User Attributes"
    type ModalKeys = 'createAttribute' | ''
    const { updateDataContext } = usePageContext();

    const breadCrumb = [
        { linkItem: false, title: 'IAM' },
        { linkItem: false, title: pageTitle },
    ]

    const getAttributeDefinitions = async () => {
        let { status, httpStatus, data } = state

        try {
            const response: any = await HttpServices.httpGet(IDAM.ATTR_DEFINITIONS)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payload: any = response.data.payload
                data.grouping = payload.attr

                status = 'fulfilled'
                dataContextHandler(status)
            } else {
                status = 'rejected'
            }
        } catch (error) {
            status = 'rejected'
            httpStatus = 0
        }

        setstate((prevState: any) => ({
            ...prevState,
            status,
            httpStatus,
            data: {
                ...prevState.data,
            },
        }))
    }

    useEffect(() => {
        dataContextHandler()
        getAttributeDefinitions()
    }, [])

    const dataContextHandler = (status: string = 'pending') => {
        const baseContext = {
            title: pageTitle,
        }

        // Early return if data is not ready
        if (status !== 'fulfilled') {
            updateDataContext(baseContext)
            return
        }

        updateDataContext({
            ...baseContext,
            mainAction: {
                visible: true,
                disabled: false,
                icon: 'far fa-plus',
                label: 'Create Attribute',
                onClick: () => toggleModal('createAttribute', true),
                variant: 'primary' /* | 'secondary' | 'danger' | string */,
            }
        })
    }

    const toggleModal = (key: ModalKeys, value: boolean, uuid?: any) => {
        setstate((prevState: any) => ({
            ...prevState,
            show: {
                ...prevState.show,
                modal: value ? key : '',
                uuid: uuid,
            },
        }))
    }

    const activateTab = (tabName: any) => {
        setstate({
            ...state,
            activeTab: tabName
        })
    }

    const navigateToEditUserAttribute = (attr: any) => {
        const navigationState = {
            previous_path: location.pathname,
            title: attr.e
        }

        let navigationRoute = getStandardRoute('USER.EDIT_ATTR_')

        navigationRoute = [":attribute"]
            .reduce((route, param, index) =>
                RouteHydration(route, param, [attr.g][index]),
                navigationRoute
            );

        return navigate(navigationRoute, { replace: false, state: navigationState });
    }


    const loadRespectiveTab = (tab: string = 'attributes') => {
        switch (tab) {
            case 'attributes':
                return <AttributeListingTab
                    data={state.data}
                    pageTitle={pageTitle}
                />

            case 'groups':
                return <GroupListingTab />

            default:
                return null
        }
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>

            <div className="flex flex-col gap-x-3 w-full mx-auto h-full">
                {
                    state.status === 'rejected' ? (
                        <div className="py-2 px-6 w-full mx-auto flex-1 flex flex-col justify-center">
                            <ErrorState
                                code={state.httpStatus}
                            />
                        </div>
                    ) : state.status === 'fulfilled' ? (
                        <>
                            <div className="w-full py-2 border-b border-slate-200 dark:border-slate-600 lg:px-6 px-5 flex flex-col">
                                <div className="flex-none">
                                    <ModuleBreadCrumb breadCrumb={breadCrumb} />
                                </div>
                            </div>

                            <div className="md:h-full lg:h-full flex flex-col w-full">
                                <div className="header-title w-full align-middle title-transition lg:px-6 px-5 pt-3">
                                    <p className="text-slate-600 dark:text-slate-300 md:pt-2 lg:pt-2 pb-4 text-sm md:w-[768px]">
                                        <span className="hidden md:block">
                                            Define and manage custom user attributes used to categorize, identify, or extend user profiles. Attributes can include fields like designation, department, or region.
                                        </span>

                                        <span className="md:hidden">
                                            Define and manage custom user attributes used to categorize, identify, or extend user profiles.
                                        </span>
                                    </p>
                                </div>

                                <div className="md:h-full lg:h-full flex flex-col">
                                    <div className="w-full h-full md:px-3 px-1.5 flex-1">
                                        <div className="w-full lg:px-3 px-4 pt-3 pb-28">
                                            <div className="overflow-x-auto">
                                                <div className="md:w-full min-w-flex flex-col gap-y-3 pb-20 relative transition-colors overflow-x-auto">
                                                    {
                                                        state.data.grouping.map((group: any) => (
                                                            <div key={`dfnt-gro-${group.g}`} className="pb-4">
                                                                <header className="md:max-w-[768px] w-full mb-2 header-title">
                                                                    <p className="text-lg text-slate-700 dark:text-slate-200 font-medium pb-1">
                                                                        {group.e}
                                                                    </p>

                                                                    <span className="text-sm pb-2 text-slate-500 dark:text-slate-300 block">
                                                                        {group.t}
                                                                    </span>
                                                                </header>

                                                                <div className="w-full grid grid-cols-4 md:grid-cols-[minmax(170px,1fr)_minmax(100px,1fr)_32px] gap-4 dark:bg-slate-900/30 border-b border-slate-300 dark:border-slate-600 py-2.5 text-left text-sm text-slate-400 dark:text-slate-400 tracking-wider px-2">
                                                                    <div className="block">
                                                                        Name
                                                                    </div>

                                                                    <div className="hidde md:block">
                                                                        Type
                                                                    </div>

                                                                    <span className="hidde md:block"></span>
                                                                </div>

                                                                {
                                                                    group.s.length > 0 ? (
                                                                        group.s.map((attr: any) => (
                                                                            <div key={`attr-def-${attr.g}`} className="grid grid-cols-1 md:grid-cols-[minmax(170px,1fr)_minmax(100px,1fr)_32px] gap-x-4 gap-y-1 px-2 py-2 hover:bg-slate-100 dark:hover:bg-slate-700 border-b border-slate-200 dark:border-slate-700 text-sm align-middle items-center">
                                                                                <div className="text-slate-700 dark:text-slate-200 md:block flex flex-col align-middle md:items-center">
                                                                                    <div className="flex items-center align-middle gap-x-2">
                                                                                        <span className="block" aria-disabled={!attr.n}>
                                                                                            {attr.e}
                                                                                        </span>

                                                                                        {
                                                                                            !attr.n && (
                                                                                                <span className="inline-flex bg-red-50 dark:bg-red-800/20 text-red-600 dark:text-red-400 ring-red-300 dark:ring-red-600 rounded-md px-1.5 py-0.5 text-xs ring-1 ring-inset capitalize">
                                                                                                    Deactivated
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                    </div>

                                                                                    <span aria-disabled={!attr.n} className="text-xs block text-slate-500 dark:text-slate-400">
                                                                                        {attr.t ?? '-'}
                                                                                    </span>
                                                                                </div>

                                                                                <div className="text-slate-600 dark:text-slate-300">
                                                                                    <div className="flex gap-x-3 items-center align-middle">
                                                                                        <span className="flex gap-x-2 items-center align-middle">
                                                                                            <span className={`fa-light ${dataTypeMappings[attr.f?.format].icon}`}></span>

                                                                                            {dataTypeMappings[attr.f?.format].label}
                                                                                        </span>

                                                                                        {
                                                                                            !attr.m && (
                                                                                                <span className="bg-sky-50 dark:bg-sky-800/10 text-sky-600 dark:text-sky-400 ring-sky-400/70 rounded-md px-2 py-1 text-xs ring-1 ring-inset capitalize text-center">
                                                                                                    {attr.m ? 'Mandatory' : 'Optional'}
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                <div className="h-full flex items-center">
                                                                                    <div className="flex-none">
                                                                                        <DropDown
                                                                                            type={'borderless'}
                                                                                            items={
                                                                                                <div className="w-40">
                                                                                                    <MenuItem>
                                                                                                        <button type="button" onClick={() => navigateToEditUserAttribute(attr)} className="w-full rounded-md px-3 py-2 text-sm data-[focus]:bg-slate-200 dark:data-[focus]:bg-slate-700 dark:data-[focus]:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-800 text-start">
                                                                                                            Edit Attribute
                                                                                                        </button>
                                                                                                    </MenuItem>

                                                                                                    <div className="pt-1 mb-1 w-[90%] mx-auto border-b border-slate-300 dark:border-slate-600"></div>

                                                                                                    <MenuItem>
                                                                                                        <button type="button" /* onClick={() => handleProviderCatalog(catalog)} */
                                                                                                            className="w-full rounded-md px-3 text-red-700 dark:text-red-600 py-2 text-sm data-[focus]:bg-red-200 dark:data-[focus]:bg-red-900 data-[focus]:text-red-900 dark:data-[focus]:text-white hover:bg-red-200 dark:hover:bg-red-800 text-start">
                                                                                                            Disable
                                                                                                        </button>
                                                                                                    </MenuItem>
                                                                                                </div>
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <div className="text-start text-sm text-slate-500 dark:text-slate-400 py-2 px-2">
                                                                            No {group.e} attributes to display.
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="flex-1 flex flex-col justify-center w-full overflow-auto py-4">
                            <LoadingXL />
                        </div>
                    )
                }
            </div>

            <CreateAttribute
                show={state.show.modal === 'createAttribute' ? true : false}
                showOrHide={() => toggleModal('createAttribute', false)}
            />
        </React.Fragment >
    )
}